import classNames from "classnames";
import useTranslate from "hooks/useTranslate";
import "./styles.sass";

export default function ConfirmPasswordBanner() {
  const { VITE_APP_PROJECT_NAME } = import.meta.env;
  const t = useTranslate();

  const bannerClass = classNames({
    // eslint-disable-next-line camelcase
    ConfirmPasswordForm__bannerGlory: VITE_APP_PROJECT_NAME === "glory",
    // eslint-disable-next-line camelcase
    ConfirmPasswordForm__bannerBanger: VITE_APP_PROJECT_NAME === "banger",
  });

  const titleClass = classNames({
    // eslint-disable-next-line camelcase
    ConfirmPasswordForm__titleGlory: VITE_APP_PROJECT_NAME === "glory",
    // eslint-disable-next-line camelcase
    ConfirmPasswordForm__titleBanger: VITE_APP_PROJECT_NAME === "banger",
  });

  return (
    <div className={bannerClass}>
      <div className="ConfirmPasswordForm__wrapperText">
        <div className={titleClass}>
          {t("confirm.password.popup.bonus.first")}
        </div>

        <div className="ConfirmPasswordForm__text">
          {t("confirm.password.popup.bonus.second")}
        </div>

        <div className="ConfirmPasswordForm__text">
          {t("confirm.password.popup.bonus.third")}
        </div>
      </div>

      <div>
        <img
          src="https://diswdgcu9cfva.cloudfront.net/images/image-gift-bonus.webp"
          alt="Tooltip"
        />
      </div>
    </div>
  );
}
